import { RegexEnum } from '../../libs/enums';
import { mustBeFilled, mustMatchFormat } from '../../libs/validators';

const INPUT_NAME = 'sessionId';

export const inputSessionIdConfig = {
  description: 'Le code d’identification est indiqué dans l’alerte de connexion reçue par mail',
  info: 'Ce code permet à nos équipes d’identifier facilement la connexion frauduleuse',
  label: 'Code d’identification',
  name: INPUT_NAME,
  validators: {
    format: [
      mustMatchFormat(
        RegexEnum.UUIDV4,
        'Le code est erroné, veuillez vérifier la valeur indiquée dans l’alerte de connexion reçue par mail',
      ),
    ],
    submit: mustBeFilled(
      'Veuillez renseigner le code d’identification indiqué dans l’alerte de connexion reçue par mail',
    ),
  },
};
